import { Card, Steps } from "antd";
import styled from "styled-components";

export const StyledSteps = styled(Steps)`
  padding: 0 10px;
  margin-bottom: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const StepWrapper = styled.div`
  
  width: 100%;
  
  

  
`;
export const SpanLined = styled.span`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  grid-column-gap: 1rem;
  align-items: center;
  font-size: 16px;
  font-style: italic;
  color: #42005a;

  &::before {
    content: "";
    height: 1.5px;
    display: block;
    background-color: #42005a;
  }
  &::after {
    content: "";
    height: 1.5px;
    display: block;
    background-color: #42005a;
  }
`;


export const MapCard = styled(Card) `
border-radius: 8px;
  overflow: hidden;
  height: 400px;
  width: 100%;

`
  
  

